export default "__VITE_ASSET__COZZ5MM0__"